import DOMPurify from "dompurify";

const HTML_TAG_REGEX = /<[a-z][\s\S]*>/i;

export const isHtmlDescription = (value: string) => HTML_TAG_REGEX.test(value);

export const sanitizeReportDescription = (html: string) =>
  DOMPurify.sanitize(html, {
    FORBID_TAGS: ["style", "script", "iframe", "form", "input", "button"],
  });

export const isEmptyReportDescription = (value?: string | null) => {
  if (!value) return true;

  const text = value
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();

  return text.length === 0;
};

export const plainTextToHtml = (value: string) => {
  const escaped = value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  return escaped
    .split(/\r?\n/)
    .map((line) => `<p>${line}</p>`)
    .join("");
};
